var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var DocumentMetaDicts = require('../../data/document-meta-dict');

var DocumentMetaForm = Marionette.View.extend({
    template: require('../../templates/documents/document-meta-form.html'),

    regions: {},

    ui: {
        metaVal: '.meta-val',
        metaValues: '.meta-values',
        dateField: '.date-value',

        addValueControl: '.add-value',
        removeValueControl: '.remove-value',

        expandAll: "#expand-all",
        collapseAll: "#collapse-all",
        expandRequired: "#expand-required",
        expandFilled: "#expand-filled",

        panelCollapse: ".panel-collapse"
    },

    events: {
        'change @ui.metaVal': 'onChangeMetaVal',
        'click @ui.addValueControl': 'addValue',
        'click @ui.removeValueControl': 'removeValue',

        'click @ui.expandAll': 'onExpandAll',
        'click @ui.collapseAll': 'onCollapseAll',
        'click @ui.expandRequired': 'onExpandRequired',
        'click @ui.expandFilled': 'onExpandFilled',
    },

    childViewEvents: {},

    templateContext: function () {
        var that = this;
        return {
            getFieldTitle: function (field) {
                return DocumentMetaDicts.documentMetaFields[field]
            },
            getPredefinedMetaCodesOrCodeNames: function (key, selectedValue, index) {
                var result = that.utils.getPredefinedMetaCodesOrCodeNames(key, index);

                if (!_.contains(result, selectedValue))
                    result.push(selectedValue);

                return result;
            },
            isMultipleValueAllowed: function (field) {
                return _.contains(["sourcePatientInfo", "authorInstitution", "authorRole", "authorSpecialty", "eventCode", "intendedRecipient"], field);
            },
            addMoreValuesText: "Add more values",
            getMimeTypes: function (selected) {
                var mimeTypes = DocumentMetaDicts.documentMimeTypes;
                if (!_.contains(mimeTypes, selected))
                    mimeTypes.push(selected);
                return mimeTypes;
            },
            requiredDocumentMetaFields: function (field) {
                var found = _.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: field});
                return found ? '<span style="color: red">*</span>' : "";
            },
            requiredDocumentMetaFieldsValues: function (field, subfield) {
                var found = _.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: field});
                return found && _.contains(found.required, subfield) ? '<span style="color: red">*</span>' : "";
            }
        }
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();

        that.model = new Backbone.Model({
            meta: options.meta,
            metadataId: options.metadataId,
            documentId: options.documentId
        });

        that.successCallback = options.successCallback;
    },

    onRender: function () {
        var that = this;

        this.$(that.ui.metaValues).selectize({
            createOnBlur: true,
            create: true,
            inputClass: 'form-control selectize-input normal-width'
        });

        that.ui.dateField.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'YYYYMMDDHHmmss'
        });
        that.ui.dateField.on("dp.change", function (e) {
            that.onChangeMetaVal(e);
        }).on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
        });

        that.hideCollapseButtons();
    },

    onChangeMetaVal: function (event) {
        var that = this;
        var val = event.target.value;
        var nameAndIndex = event.target.id.split(' ');
        var name = nameAndIndex[0];
        var index = nameAndIndex[1];
        var valueIndex = nameAndIndex[2];

        var meta = that.model.get('meta');
        if (name === 'value') {
            meta[index][name][valueIndex] = val;
        } else {
            meta[index][name] = val;
        }

        that.model.set('meta', meta);
    },

    saveMeta: function () {

        var that = this;

        var meta = that.model.get('meta');
        console.log(meta);
        var documentId = that.model.get('documentId');
        var metadataId = that.model.get('metadataId');

        if (metadataId) {

            $.ajax({
                type: "PUT",
                url: '/api/document/meta/' + documentId + '/' + metadataId,
                data: JSON.stringify(meta),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        that.triggerMethod('meta:saved');
                        $.notify("Document meta was updated successfully", "success");

                        if (_.isFunction(that.successCallback))
                            that.successCallback();
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            });
        } else {

            $.ajax({
                type: "POST",
                url: '/api/document/meta/' + documentId,
                data: JSON.stringify(meta),
                contentType: 'application/json',
                statusCode: {
                    200: function (response) {
                        that.triggerMethod('meta:saved');
                        $.notify("Document meta was added successfully", "success");

                        if (_.isFunction(that.successCallback))
                            that.successCallback();
                    }
                },
                error: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            });
        }
    },

    addValue: function (event) {
        var that = this;
        var ids = event.target.id.split(' ');
        var index = ids[1];
        var meta = that.model.get('meta');
        meta[index]['value'].push("");
        that.model.set('meta', meta);
        that.reRender(meta[index].field, index, $(event.target).offset().top);
    },

    removeValue: function (event) {
        var ids = event.target.id.split(' ');
        var index = ids[1];
        var valueIndex = ids[2];
        var meta = this.model.get('meta');
        meta[index]['value'].splice(valueIndex, 1);
        this.model.set('meta', meta);
        this.reRender(meta[index].field, index, $(event.target).offset().top);
    },

    reRender: function (fieldName, index, topPosition) {
        this.render();
        window.setTimeout(function () {
            $('#' + fieldName + index).collapse('toggle');
            $('html, body').animate({
                scrollTop: topPosition
            }, 1000);
        }, 0);
    },

    onExpandAll: function () {
        this.ui.panelCollapse.collapse("show");
        this.hideExpandButtons();
        this.showCollapseButtons();
    },

    onCollapseAll: function () {
        this.ui.panelCollapse.collapse("hide");
        this.hideCollapseButtons();
        this.showExpandButtons();
    },

    onExpandRequired: function () {
        this.ui.panelCollapse.each(function (i, element) {
            var self = $(this);
            var id = element.id;
            var fieldName = id.replace(i, "");
            if (_.findWhere(DocumentMetaDicts.requiredDocumentMetaFields, {field: fieldName})) {
                self.collapse('show');
            }
        });
        this.hideExpandButtons();
        this.showCollapseButtons();
    },

    onExpandFilled: function () {
        var that = this;
        var meta = that.model.get('meta');

        this.ui.panelCollapse.each(function (i, element) {
            var self = $(this);
            var id = element.id;
            var fieldName = id.replace(i, "");
            var metaForField = meta[i];
            if (!_.isEmpty(metaForField.codingScheme) || !_.isEmpty(metaForField.description) || !_.isEmpty(metaForField.nameLocalizedString)
                || !_.isEmpty(metaForField.nodeRepresentation) || !_.isEmpty(metaForField.related) || !_.isEmpty(metaForField.slotName)
                || (!_.isEmpty(metaForField.value) && metaForField.value.filter(function (v) {
                    return !_.isEmpty(v);
                }).length > 0)) {
                self.collapse('show');
            }
        });
        this.hideExpandButtons();
        this.showCollapseButtons();
    },

    hideExpandButtons: function () {
        this.ui.expandAll.hide();
        this.ui.expandRequired.hide();
        this.ui.expandFilled.hide();
    },

    showExpandButtons: function () {
        this.ui.expandAll.show();
        this.ui.expandRequired.show();
        this.ui.expandFilled.show();
    },

    hideCollapseButtons: function () {
        this.ui.collapseAll.hide();
    },

    showCollapseButtons: function () {
        this.ui.collapseAll.show();
    },
});

module.exports = DocumentMetaForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/document-meta-form.js
// module id = 395
// module chunks = 0